import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock, Loader2, ShieldCheck } from 'lucide-react';
import AdminDashboard from '../components/AdminDashboard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'mold_admin_token';

const Admin = () => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || '');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      setToken(res.data.token);
      toast.success('Welcome back!');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken('');
    setEmail(''); setPassword('');
  };

  if (token) return <AdminDashboard token={token} onLogout={logout} />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f4f7f0] px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/assets/360moldlogo.png" alt="360 Mold Services" className="h-14 mx-auto" />
        </div>
        <div className="bg-white rounded-[1.5rem] shadow-[0_20px_50px_-24px_rgba(20,50,25,0.25)] border border-[#eef2e8] p-8">
          <div className="flex items-center gap-2 text-brand font-semibold">
            <ShieldCheck className="h-5 w-5" /> Admin Access
          </div>
          <h1 className="mt-2 text-2xl font-bold text-[#13251b]">Leads Dashboard</h1>
          <p className="mt-1 text-sm text-[#5b6a60] mb-6">Sign in to view and manage booking requests.</p>
          <form onSubmit={login} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" autoComplete="username" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-brand hover:bg-[#5c9a22] text-white rounded-full font-semibold h-12">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4 mr-2" /> Sign In</>}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Admin;
